import Api from '@/api'
const resource = 'banks'

export default {
  fetchContracts (id) {
    return Api.get(`/${resource}/${id}/contracts`)
  },

  find (id) {
    return Api.get(`/${resource}/${id}`)
  },

  list () {
    return Api.get(`/${resource}`)
  }
}
